<div class="auth-page auth-page--flow">
  <div class="auth-page__grid">
    <app-auth-showcase-aside />

<main class="auth-main auth-main--flow">
      <div class="auth-main__content">
        <a class="auth-brand" [routerLink]="['/authentication']">
          <img
            src="/assets/images/logos/logo.svg"
            class="auth-brand__logo"
            [attr.alt]="'auth.verifyEmail.logoAlt' | translate"
          />
        </a>

        <div class="auth-panel">
          <h1 class="auth-panel__title">{{ 'auth.verifyEmail.title' | translate }}</h1>
          <p class="auth-panel__subtitle">
            {{ 'auth.verifyEmail.subtitle' | translate: { email: email() } }}
          </p>

          <div class="verify-email-otp" authScrollOnFocus>
            <app-otp-code-input
              [length]="otpCodeLength"
              [disabled]="submitting()"
              [invalid]="otpError() && !otpSendError()"
              [resetToken]="otpResetToken()"
              (codeChange)="onCodeChange($event)"
              (completed)="onCompleted($event)"
            />

            @if (otpError()) {
              <p class="auth-form-error" role="alert">
                {{
                  (otpSendError()
                    ? 'auth.verifyEmail.sendFailed'
                    : 'auth.verifyEmail.invalid'
                  ) | translate
                }}
              </p>
            }

            <div class="verify-email-otp__resend">
              @if (otpRetryAfter() > 0) {
                <p>{{ otpResendWaitKey() | translate: { wait: otpResendWaitLabel() } }}</p>
              } @else {
                <p>{{ 'auth.verifyEmail.resendPrompt' | translate }}</p>
                <button
                  type="button"
                  class="auth-link"
                  (click)="resend()"
                  [disabled]="submitting()"
                >
                  {{ 'auth.verifyEmail.resend' | translate }}
                </button>
              }
            </div>
          </div>

          <button type="button" class="auth-link verify-email-otp__signout" (click)="signOut()">
            {{ 'auth.verifyEmail.signOut' | translate }}
          </button>
        </div>
      </div>
    </main>
  </div>
</div>
